import React from "react";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import styled from "styled-components";
import UnstyledButton from "./library/UnstyledButton";

type ScrollDownButtonProps = {
  to: React.MutableRefObject<HTMLDivElement>;
};

const ScrollDownButton = ({ to }: ScrollDownButtonProps) => {
  const scroll = () => {
    to.current.scrollIntoView({
      block: "start",
      inline: "nearest",
      behavior: "smooth",
    });
  };

  return (
    <ButtonWrapper>
      <ScrollButton onClick={scroll} id="scroll-down-button">
        <FontAwesomeIcon icon={faChevronDown} />
      </ScrollButton>
    </ButtonWrapper>
  );
};

const ButtonWrapper = styled.div`
  position: sticky;
  bottom: 0;
  width: 100%;
  text-align: center;
  margin-top: 1rem;
`;

const ScrollButton = styled(UnstyledButton)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  color: ${({ theme }) => theme.colors.gray700};
  background-color: ${({ theme }) => theme.colors.gray200};
  border-radius: 50%;
  opacity: 0.5;
  transition: opacity 120ms ease-in-out;

  &:hover {
    opacity: 0.75;
  }
`;

export default ScrollDownButton;
